import Dot3Icon from "../../gui/Icons/Dot3Icon";
import { TMenuRow } from "../../gui/Menu/Menu";
import MenuButton from "../../gui/Menu/MenuButton";
import DateRangeFilter from "../widgets/DateRangeFilter";
import AccountFilter from "../widgets/AccountFilter";
import SearchFilter from "../widgets/SearchFilter"
import PortUtils from "../../portlibs/PortUtils";

export default function HomeToolbar(props:{onExport:Function}){
    const MenuOptions : TMenuRow<string>[] = [
        {id:"add",text:"New Equity",url:{hash:PortUtils.createHash("", "add")}},
        {id:"export",text:"Export",onClick:() => props.onExport()}
    ]
    return <div className="toolbar flex middle gap-8">
        <AccountFilter/>
        <SearchFilter/>
        <DateRangeFilter/>
        <MenuButton menuProps={{options:MenuOptions}} className="icon"><Dot3Icon/></MenuButton>
    </div>
}